
import { Options, Vue } from 'vue-class-component';
import ProductCardOrderable from "@/components/ProductCardOrderable.vue";
import RegionService from "@/services/RegionService";
import { Product } from "@/data/products";
import { Region } from "@/data/region";

@Options({
    props: {
        regionId: {
            type: Number,
            required: true,
        },
        region: {
            type: Object,
            required: false,
            default: null,
        }
    },
    methods: {

    },
    components: {
        ProductCardOrderable,
    },
})
export default class RegionProducts extends Vue {
    regionId!: number
    region!: Region|null

    loading = true

    products: Product[] = []

    loadProducts() {
        this.loading = true;
        return RegionService.getRegionProducts(this.regionId).then(result => {
            this.products = result.data.data;
        }).finally(() => this.loading = false);
    }

    mounted() {
        this.loadProducts();
    }
}
